import classnames from 'classnames';
import './AppStoreLink.scss';

const AppStoreLink = ({
  datatestid,
  appStoreClass,
  handleAppDownloadClick,
  type,
  isDesktop,
}) => {
  const linkClass = classnames('app-download-store link', appStoreClass);
  return (
    <div
      onClick={e => {
        handleAppDownloadClick(e, type, isDesktop);
      }}
      className="m-margLRAuto styleForAppDownloadModule"
    >
      <div data-testid={`${datatestid}-downloadImage`} className={linkClass} />
    </div>
  );
};

export default AppStoreLink;
